import { useState } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

const ApplicationLogo = ({ url, name }) => {
  const [valid, setValid] = useState(true)

  const onError = () => {
    setValid(false)
  }

  const hasLogo = url && valid

  return <div className={classnames("integration-logo-container", { "has-logo": hasLogo })}>
    {hasLogo && <img
      src={`https://assets.ompnt.com/partner-logos/${url}`}
      alt={`${name} logo`}
      className="integration-logo"
      onError={onError}
    />}
  </div>
}

ApplicationLogo.propTypes = {
  url: PropTypes.string,
  name: PropTypes.string.isRequired,
}

export default ApplicationLogo
